<template>
  <div>
      <!-- <h2 class="text-1xl font-bold text-gray-700">
        Listado de ventas
      </h2> -->
    <MainListSales />
  </div>
</template>

<script>
import MainListSales from "@/components/Sales/MainListSales.vue";
import { useRoute } from "vue-router";
import { onBeforeMount, onMounted } from "vue";
import { findSubmoduleIdByDescription } from "@/hisAcces";
export default {
  name: "SalesList",
  components: {
    MainListSales,
  },
  setup() {
    const route = useRoute();
    onBeforeMount(() => {
      if (!findSubmoduleIdByDescription(route.path)) {
        window.location.href = "/login";
      }
    });

    onMounted(() => {
      document.title =
        route.meta.title + process.env.VUE_APP_TITLE ||
        process.env.VUE_APP_TITLE;
    });
  },
};
</script>
